import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import mainReducer from './mainReducer';

const { NODE_ENV } = process.env;

let composeEnhancers = compose;

if (NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    trace: true,
  });
}

export default (initialState) => createStore(
    mainReducer,
    initialState,
    composeEnhancers(applyMiddleware(thunk)),
);
